<template>
    <div class="row">
        <div :class="['col-12', admin_mode ? 'col-md-6' : '']">
            <select class="form-control"
                    id="status"
                    name="status"
                    type="text"
                    v-model="val"
                    >
                <option v-for="element in statuses"
                        :value="element['jira_id']"
                        :selected="element['jira_id'] === val">
                    <template v-if="admin_mode">{{ element['transition_name'] }}</template>
                    <template v-else>{{ element['sos_name'] }}</template>
                </option>
            </select>
        </div>
        <div class="col-12 col-md-4" v-if="admin_mode">
            <span class="badge badge-dynamic" :style="{'background-color': color}">{{name}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "jira-status-select",
    props: {
        value: Number|String|Object|null,
        statuses: Array|Object|null,
        admin_mode: {type: Boolean, required: false, default: true},
    },
    data() {
        return {
            val: null
        }
    },
    computed: {
        color() {
            return this.statuses.filter(x => x.jira_id == this.val)[0].mapped_status.color;
        },
        name() {
            return this.statuses.filter(x => x.jira_id == this.val)[0].mapped_status.name;
        }
    },

    created() {
        this.val = this.value;
    },
    watch: {
        val() {
            this.$emit('input', this.val)
        }
    }

}
</script>
